import {BasePanelWidget} from "../../BasePanelWidget";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {RadioList} from "mu-widget/lib/components/InputList";
import {customizeRadioListBar} from "../../customize";
import {addFlash} from "../../utils";
import {t} from "../../translate";
import {frontAppConfig} from "../../FrontAppConfig";

export class UiVisual extends BasePanelWidget {
    // @ts-ignore
    muNamedWidget: MuNamedWidgets<{
        theme: RadioList,
    }>;

    protected frontAppConfig = frontAppConfig;

    beforeIndex() {
        this.muAppendContent(`
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="theme">${t('visualThemeLabel')}</label>
                <div class="c-form-pair__control-container">
                    <div mu="theme:RadioList#theme" />
                </div>
            </div>
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="fontSize">${t('visualFontSizeLabel')}</label>
                <div class="c-form-pair__control-container">
                    <input type="range" mu="fontSize#fontSize" min="62" max="150" />
                </div>
                <div class="d-flex-row">
                    <div mu="fontSizeMin" class="flex-grow-1">${t('fontSizeMin')}</div>
                    <div mu="fontSizeNormal" class="flex-grow-1 text-align-center">${t('fontSizeNormal')}</div>
                    <div mu="fontSizeMax" class="flex-grow-1 text-align-right">${t('fontSizeMax')}</div>
                </div>
            </div>
            <div class="buttons">
                <button mu="bSave" class="btn btn--primary">${t('genSave')}</button>
                <button mu="bCancel" class="btn btn--cancel">${t('genCancel')}</button>
            </div>
        `);
    }

    async afterIndex(): Promise<any> {
        this.muNamedWidget.theme.visual.addParamDef(customizeRadioListBar({}));
        this.muNamedWidget.theme.items = [
            { value: 'auto', text: t('visualThemeAuto') },
            { value: 'dark', text: t('visualThemeDark') },
            { value: 'light', text: t('visualThemeLight') },
        ];

        const sizes: [string, number][] = [
            ['fontSizeMin', 62],
            ['fontSizeNormal', 100],
            ['fontSizeMax', 150],
        ];

        for(const [key, size] of sizes) {
            this.ui[key].style.fontSize = (size * 0.16).toString() + 'px';
        }

        this.muBindData(this.frontAppConfig);
    }
    fontSizeMin_click() { this.setFontSize('min'); }
    fontSizeNormal_click() { this.setFontSize(100); }
    fontSizeMax_click() { this.setFontSize('max'); }

    theme_change() { this.preview(); }
    fontSize_change() { this.preview(); }

    async bSave_click() {
        const data = this.muFetchData();
        this.frontAppConfig.updateAndSaveConfig(data);
        addFlash(t('visualSettingsSaved'));
        await this.closeMe();
    }

    async bCancel_click() {
        this.frontAppConfig.applyVisual();
        await this.closeMe();
    }

    private preview() {
        const data = this.muFetchData();
        this.frontAppConfig.applyVisual(data);
    }

    private setFontSize(value: 'min'|'max'|number) {
        const fsi = this.ui.fontSize as HTMLInputElement;
        switch(value) {
            case 'min': fsi.value = fsi.min; break;
            case 'max': fsi.value = fsi.max; break;
            default: fsi.value = value.toString(); break;
        }
        this.preview();
    }
}